var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagesPeopleBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16C3.35969 16.0044 0.00440928 19.3597 0 23.5C0 23.7761 0.223858 24 0.5 24H14.5C14.7761 24 15 23.7761 15 23.5C14.9956 19.3597 11.6403 16.0044 7.5 16V16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.5C10.1234 15.5 12.25 13.3734 12.25 10.75C12.25 8.12665 10.1234 6 7.5 6C4.87665 6 2.75 8.12665 2.75 10.75C2.75 13.3734 4.87665 15.5 7.5 15.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.116 6.5C13.6683 6.5 14.116 6.05228 14.116 5.5C14.116 4.94772 13.6683 4.5 13.116 4.5C12.5637 4.5 12.116 4.94772 12.116 5.5C12.116 6.05228 12.5637 6.5 13.116 6.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.366 6.5C16.9183 6.5 17.366 6.05228 17.366 5.5C17.366 4.94772 16.9183 4.5 16.366 4.5C15.8137 4.5 15.366 4.94772 15.366 5.5C15.366 6.05228 15.8137 6.5 16.366 6.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.616 6.5C20.1683 6.5 20.616 6.05228 20.616 5.5C20.616 4.94772 20.1683 4.5 19.616 4.5C19.0637 4.5 18.616 4.94772 18.616 5.5C18.616 6.05228 19.0637 6.5 19.616 6.5Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 -1.33647e-07H12.5C10.415 -0.00648327 8.50802 1.17395 7.584 3.043C7.42448 3.36275 7.44767 3.74332 7.64482 4.04134C7.84198 4.33937 8.18315 4.50957 8.53982 4.48784C8.89649 4.46611 9.21448 4.25575 9.374 3.936C9.96127 2.74709 11.174 1.99604 12.5 2H18.5C20.433 2 22 3.567 22 5.5C22 7.433 20.433 9 18.5 9H17.5C17.2728 8.99989 17.0524 9.07713 16.875 9.219L15.997 9.919C15.9548 9.39972 15.521 8.99985 15 9H14C13.4477 9 13 9.44771 13 10C13 10.5523 13.4477 11 14 11V12C13.9999 12.3845 14.2202 12.7351 14.5668 12.9017C14.9134 13.0683 15.3248 13.0213 15.625 12.781L17.851 11H18.5C21.5376 11 24 8.53757 24 5.5C24 2.46243 21.5376 -1.33647e-07 18.5 -1.33647e-07Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesPeopleBubble);
export default __webpack_public_path__ + "static/media/messagesPeopleBubble.e6cf5fe2.svg";
export { ForwardRef as ReactComponent };